









import Vue, { PropType } from 'vue'
import { WidgetSettingsSelectbox } from '../widgets/base/widget/WidgetInterface'

export default Vue.extend({
  props: {
    setting: {
      type: Object as PropType<WidgetSettingsSelectbox>,
      required: true,
      default: {}
    },
    value: {
      type: [String, Number] as PropType<string | number>,
      required: true,
      default: ''
    }
  }
})
